// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"385":"router","836":"hanzi-writer","905":"videos","981":"raven"}[chunkId] || chunkId) + "." + {"385":"50d3766b","549":"105c9716","574":"f86cc76f","663":"5a9997ec","733":"721ff5b3","836":"1a9e68e1","905":"3c062b2a","981":"a9c836b6"}[chunkId] + ".js";
};